import React from "react";

import {
	Heading,
	HStack,
	Icon,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
	VStack,
} from "@chakra-ui/react";

import { MODAL_BODY_PROPS, MODAL_CONTENT_PROPS, MODAL_FOOTER_PROPS, MODAL_OVERLAY_PROPS } from "./modalTokens";
import { usePropertyModalTheme } from "./usePropertyModalTheme";

export default function PropertyModalShell({
	isOpen,
	onClose,
	size = "4xl",
	icon,
	title,
	subtitle,
	headerExtra,
	children,
	footer,
	scrollBehavior = "inside",
}) {
	const { borderColor, iconColor } = usePropertyModalTheme();

	return (
		<Modal isOpen={isOpen} onClose={onClose} size={size} scrollBehavior={scrollBehavior}>
			<ModalOverlay {...MODAL_OVERLAY_PROPS} />
			<ModalContent {...MODAL_CONTENT_PROPS}>
				<ModalHeader borderBottom="1px" borderColor={borderColor} pb={3} pt={4} px={6}>
					<HStack spacing={3} align="start" pr={8}>
						{icon && <Icon as={icon} color={iconColor} boxSize={5} mt={0.5} flexShrink={0} />}
						<VStack align="start" spacing={0} flex={1}>
							<Heading size="sm">{title}</Heading>
							{subtitle && (
								<Text fontSize="xs" color="gray.500">
									{subtitle}
								</Text>
							)}
						</VStack>
						{headerExtra}
					</HStack>
				</ModalHeader>
				<ModalCloseButton top={3} />
				<ModalBody {...MODAL_BODY_PROPS}>{children}</ModalBody>
				{footer && (
					<ModalFooter {...MODAL_FOOTER_PROPS} p={0}>
						{footer}
					</ModalFooter>
				)}
			</ModalContent>
		</Modal>
	);
}
